import React, { useEffect, useState } from "react";
import PositionsPopupsDetails from "./PositionsPopupsDetails";
import axios from "axios";
import trans from "../../../utils";
import { SpeedUnit, SpeedValue } from "../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function PositionsPopupsBody({ mark, devicestatus }) {
	const [geoCode, setGeoCode] = useState(false);
	const inf = useSelector((state) => state.users.user);
	const fetchGeoCodePosition = async (lat, lon) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);
			setGeoCode(`${response.data.display_name}`);
			return `${response.data.display_name}`;
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	useEffect(() => {
		fetchGeoCodePosition(mark?.latitude, mark?.longitude);
	}, [mark?.latitude, mark?.longitude]);
	function knotsToKmPerHour(knots) {
		return knots * 1.852;
	}
	return (
		<div className="device-popup-body" dir="ltr">
			<div className="row">
				<div className="col-lg-6">
					<PositionsPopupsDetails img="Anchor" item={geoCode} />
					<PositionsPopupsDetails img="Time" item={mark?.fixTime} />
					{mark?.attributes.ignition && (
						<PositionsPopupsDetails
							img={mark?.attributes.ignition ? "IgnitionOn" : "IgnitionOff"}
							item={mark?.attributes.ignition ? trans("ON") : trans("OFF")}
						/>
					)}
				</div>
				<div className="col-lg-6">
					{/**<PositionsPopupsDetails
            img={devicestatus ? "Available" : "Unavailable"}
            item={devicestatus ? "Available" : "Unavailable"}
          />*/}
					<PositionsPopupsDetails
						img={devicestatus ? "Connected" : "Disconnected"}
						item={devicestatus ? trans("Connected") : trans("Disconnected")}
					/>
					<PositionsPopupsDetails
						img="Speedmeter"
						item={
							devicestatus
								? SpeedUnit(mark?.speed, inf.attributes.speedUnit || "kn")
								: `0 ${trans(inf.attributes.speedUnit) || "kn"}`
						}
					/>
				</div>
			</div>
		</div>
	);
}
